// import IconChairSolar from "./assets/guardasol.svg";
import IconAirPlane from "./assets/aviao.svg";
import IconBuilding from "./assets/building.svg";
import IconSafeBox from "./assets/cofre.svg";
import IconMoutain from "./assets/mountain.svg";
import IconPlates from "./assets/plates.svg";
export const contentSectionBenefits = [
  {
    id: 1,
    icon: IconAirPlane,
    description: `São mais de 1.900 hotéis credenciados para você explorar todo o Brasil, como e quando quiser.`,
  },
  {
    id: 2,
    icon: IconBuilding,
    description: `Todas as diárias são com café da manhã incluso para você e mais um acompanhante.`,
  },
  {
    id: 3,
    icon: IconSafeBox,
    description: `Com as nossas assinaturas, você economiza até 60% do valor das diárias nos hotéis.`,
  },
  {
    id: 4,
    icon: IconMoutain,
    description: `As reservas são feitas de maneira 100% digital, basta acessar a sua conta no nosso site.`,
  },
  {
    id: 5,
    icon: IconPlates,
    description: `Sem pressa, suas diárias tem até 3 anos de validade para você utilizar quando quiser.`,
  },
  // {
  //   id: 6,
  //   icon: IconChairSolar,
  //   description: ` Exclusividade do seguro viagem incluso em todas as assinaturas,
  //     sem custo adicional.`,
  // },
];
